/**
 * Dual-title resolution for listings.
 *
 * See docs/enhancements/gopilot-dual-title.md. Two titles per listing:
 *   - attributes.title          → human display title (cards, listing H1, dashboard, emails)
 *   - publicData.seoTitle (new) → keyword-dense crawler title (<title>, OG/Twitter, JSON-LD)
 *
 * SEO-rendering surfaces call getSeoTitle so they use the seoTitle when present and
 * fall back to the display title for listings created before the dual-title change,
 * or when an owner leaves the optional SEO field blank. Display surfaces keep reading
 * attributes.title directly.
 *
 * @param {Object} listing - Listing entity from the Sharetribe SDK
 * @returns {string} trimmed seoTitle when present, else attributes.title, else ''
 */
export const getSeoTitle = listing =>
  listing?.attributes?.publicData?.seoTitle?.trim() ||
  listing?.attributes?.title ||
  '';
